import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import capsize from 'capsize';
import { css } from 'styled-components';
import { l as large } from './breakpoints-70e05b67.js';

// Taken from https://seek-oss.github.io/capsize/ after measuring Proxima-Nova
var fontMetricsRegular = {
    ascent: 1858,
    capHeight: 1320,
    descent: -597,
    lineGap: 0,
    unitsPerEm: 2048,
};
var fontMetricsSemibold = {
    ascent: 1860,
    capHeight: 1462,
    descent: -630,
    lineGap: 0,
    unitsPerEm: 2048,
};
var fontWeight = {
    regular: 'normal',
    semibold: 'bold',
};
var description = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: left;\n\n  ", "\n"], ["\n  text-align: left;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 14px/21px " + theme.fontFamilyPrimary + ";\n  ";
});
var descriptionCapsize = css(function (_a) {
    var theme = _a.theme;
    var styles = __assign({ fontFamily: theme.fontFamilyPrimary, textAlign: 'left' }, capsize({
        fontMetrics: fontMetricsRegular,
        fontSize: 14,
        leading: 21,
    }));
    return styles;
});
var error = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n\n  ", "\n"], ["\n  text-align: left;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 15px/21px " + theme.fontFamilyPrimary + ";\n  ";
});
var eyebrow = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  letter-spacing: 2px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  letter-spacing: 2px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 13px/16px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  letter-spacing: 0.1px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  letter-spacing: 0.1px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 13px/16px " + theme.fontFamilyPrimary + ";\n  ";
});
var formHeadingThin = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 18px/22px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 23px 0 54px;\n  text-align: center;\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n"], ["\n  margin: 23px 0 54px;\n  text-align: center;\n  text-transform: uppercase;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.regular + " 19px/23px " + theme.fontFamilyPrimary + ";\n  ";
}, large(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 24px;\n    line-height: 29px;\n    margin: 21px 0 50px;\n  "], ["\n    font-size: 24px;\n    line-height: 29px;\n    margin: 21px 0 50px;\n  "]))));
css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 18px/22px " + theme.fontFamilyPrimary + ";\n  ";
});
var headingLower = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 18px/22px " + theme.fontFamilyPrimary + ";\n  ";
});
var headingLowerCapsize = css(function (_a) {
    var theme = _a.theme;
    var styles = __assign({ fontFamily: theme.fontFamilyPrimary, fontWeight: fontWeight.semibold }, capsize({
        fontMetrics: fontMetricsSemibold,
        fontSize: 18,
        leading: 22,
    }));
    return styles;
});
css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  letter-spacing: 3.8px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  letter-spacing: 3.8px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 16px/19px " + theme.fontFamilyPrimary + ";\n  ";
});
// line-height of 25px taken from textarea mock
var input = "\n  " + function (_a) {
    var theme = _a.theme;
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    font: 18px/25px ", ";\n  "], ["\n    font: 18px/25px ", ";\n  "])), theme.fontFamilyPrimary);
} + "\n";
css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 15px/18px " + theme.fontFamilyPrimary + ";\n  ";
});
var inputLabel = css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 12px/21px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 13px/20px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: " + fontWeight.semibold + " 14px/17px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  text-align: center;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  text-align: center;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 11px/12px " + theme.fontFamilyPrimary + ";\n  ";
});
css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    font: 14px/18px " + theme.fontFamilyPrimary + ";\n  ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

export { headingLower as a, description as b, input as c, descriptionCapsize as d, error as e, formHeadingThin as f, eyebrow as g, headingLowerCapsize as h, inputLabel as i };
